module.exports = __webpack_public_path__ + "img/panelView_baoSteel_2_2_.ef92b2ba.png";